import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { AcademicMasterName, CreateAcademicMasterNamePayload } from "../types";

export const fetchMasterNames = async (nodeType?: string): Promise<AcademicMasterName[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.ACADEMIC_MASTER_NAMES.LIST, {
    params: nodeType ? { nodeType } : undefined,
  });
  return data.masterNames ?? data;
};

export const createMasterName = async (
  payload: CreateAcademicMasterNamePayload
): Promise<AcademicMasterName> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.ACADEMIC_MASTER_NAMES.CREATE, payload);
  return data.masterName ?? data;
};

export const deleteMasterName = async (id: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.ACADEMIC_MASTER_NAMES.DELETE(id));
};
